module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-h1-fa837eb1.svg";